<!-- orders list -->
<div class="table-responsive">
  <!-- full mode-->
  @if (mode == 'full') {
    <div>
      <orders-layout-full #layoutFull
        [items]="items"
        [isProductsAmountWithinRange]="isProductsAmountWithinRange"
        (clearAll)="onRemoveAll()"
        (updateAll)="onUpdateAll($event)"
        (clearItem)="onRemoveItem($event)">
      </orders-layout-full>
    </div>
  }
  <!-- /full mode-->

  <!-- checkout mode -->
  @if (mode == 'checkout') {
    <div>
      <orders-layout-checkout #layoutCheckout
        [items]="items">
      </orders-layout-checkout>
    </div>
  }
  <!-- /checkout mode -->
</div>
<!-- /orders list -->
